@if (logoSrc) {
<div class="el-header">
    <img class="el-header-logo" [src]="logoSrc" alt="Logo" />
    <h1 class="el-header-title">{{title}}</h1>
</div>
} @else {
<div class="el-header">
    <h1 class="el-header-title">{{title}}</h1>
</div>
}